import underscore from "lodash";
import mockNewsletters from "../data/newsletters";
import axios from "axios";
import formatDate from "../../mixins/formatDate";
import CONSTANTS from "../../settings/constants";
import store from "../../store/index.js";

// const getNewsletters = (url, config = {}) => get(url, config);

const getNewsletters = (page, filters, itemsPerPage) => {
  if (!page || isNaN(page)) {
    page = 1;
  }

  // create newsletters object including total amount of newsletters
  // so that we stop trying to load once we have shown all
  let newsletters = {
    total: 0,
    items: []
  };

  // create array of currently active filters using id strings
  let activeFilters = filters
    .filter(school => school.value)
    .map(school => school.id);
  let activeFiltersJoin = activeFilters.join(",");

  let firstDayOfLastYear = formatDate(
    new Date(new Date().getFullYear() - 1, 0, 1)
  );
  let today = formatDate(Date.now());

  let newslettersApi = `${CONSTANTS.MIDDLEWARE}/newsletters?ids=${activeFiltersJoin}&startDate=${firstDayOfLastYear}&endDate=${today}`;

  return new Promise(function(resolve, reject) {
    if (activeFilters.length > 0) {
      //eslint-disable-next-line
      NativeJS.debugLog(`Calling ${newslettersApi}`);
      let start = Date.now();
      axios
        .get(newslettersApi)
        .then(response => {
          let end = Date.now();
          let time = (end - start) / 1000;
          //eslint-disable-next-line
          NativeJS.debugLog(
            `Calling ${newslettersApi} responded after ${time} seconds with a ${response.status} code`
          );
          //eslint-disable-next-line
          NativeJS.debugLog(
            `${newslettersApi} Response body: ${JSON.stringify(
              response.data,
              null,
              2
            )}`
          );

          // flatten the array of schools newsletters into single array
          response.data.forEach(schoolNewsletter => {
            let newsletterItems =
              schoolNewsletter.items && schoolNewsletter.items.length > 0
                ? schoolNewsletter.items
                : [];
            newsletters.items = [...newsletters.items, ...newsletterItems];
          });

          // sort newsletters by date (newest to oldest)
          newsletters.items = underscore
            .sortBy(newsletters.items, function(newsletter) {
              return new Date(newsletter.date).getTime();
            })
            .reverse();

          // assign total number of newsletters for pagination and our spliced
          // selected based on itemsPerPage
          newsletters.total = newsletters.items.length;
          newsletters.items = newsletters.items.splice(0, page * itemsPerPage);

          resolve(newsletters);
        })
        .catch(error => {
          //eslint-disable-next-line
          NativeJS.debugLog(
            `error calling ${newslettersApi}: ${JSON.stringify(error, null, 2)}`
          );
          reject(error);
        });
    } else {
      resolve(newsletters);
    }
  });
};

const getIndividualNewsletter = id => {
  let individualNewsletterApi = `${CONSTANTS.MIDDLEWARE}/newsletter?id=${id}`;

  return new Promise(function(resolve) {
    let newsletter = store.getters.newsletters.items.find(
      newsletter => newsletter.id === id
    );

    if (newsletter) {
      resolve(newsletter);
    } else {
      //eslint-disable-next-line
      NativeJS.debugLog(`Calling ${individualNewsletterApi}`);
      let start = Date.now();
      axios
        .get(individualNewsletterApi)
        .then(response => {
          let end = Date.now();
          let time = (end - start) / 1000;
          //eslint-disable-next-line
          NativeJS.debugLog(
            `${individualNewsletterApi} responded after ${time} seconds with a ${response.status} code`
          );
          //eslint-disable-next-line
          NativeJS.debugLog(
            `${individualNewsletterApi} Response body: ${JSON.stringify(
              response.data,
              null,
              2
            )}`
          );

          resolve(response.data);
        })
        .catch(error => {
          //eslint-disable-next-line
          NativeJS.debugLog(
            `error calling ${individualNewsletterApi}: ${JSON.stringify(
              error,
              null,
              2
            )}`
          );
        });
    }
  });
};

const getMockNewsletters = (page, filters, itemsPerPage) => {
  if (!page || isNaN(page)) {
    page = 1;
  }
  // create newsletters object including total amount of newsletters
  // so that we stop trying to load once we have shown all
  let newsletters = {
    total: 0,
    items: []
  };

  // create array of currently active filters using id strings
  let activeFilters = filters
    .filter(school => school.value)
    .map(school => school.id);

  // only return newsletters from schools that we are including in our filter
  let filteredSchools = mockNewsletters.filter(school =>
    activeFilters.includes(school.id)
  );

  // flatten the array of schools newsletters into single array
  filteredSchools.forEach(schoolNewsletter => {
    let newsletterItems =
      schoolNewsletter.items && schoolNewsletter.items.length > 0
        ? schoolNewsletter.items
        : [];
    newsletters.items = [...newsletters.items, ...newsletterItems];
  });

  // sort newsletters by date (newest to oldest)
  newsletters.items = underscore
    .sortBy(newsletters.items, function(newsletter) {
      return new Date(newsletter.date).getTime();
    })
    .reverse();

  // assign total number of newsletters for pagination and our spliced
  // selected based on itemsPerPage
  newsletters.total = newsletters.items.length;
  newsletters.items = newsletters.items.splice(0, page * itemsPerPage);
  return new Promise(function(resolve) {
    setTimeout(function() {
      resolve(newsletters);
    }, 2000);
  });
};
export default { getNewsletters, getIndividualNewsletter, getMockNewsletters };
